/**
 * Generates an ephemeral ID for a new entity being created,
 * which can be used to track the entity in the frontend before it has a real ID from the backend.
 * The ID is prefixed with "new:" to distinguish it from real IDs.
 */
export function ephemeralCreateId(unique) {
    if (unique.startsWith("new:")) {
        return unique;
    }
    return `new:${unique}`;
}
/**
 * Checks if a given ID is an ephemeral create ID,
 * which indicates that the entity is in the process of being created
 * and does not yet have a real ID from the backend.
 */
export function isEphemeralCreateId(id) {
    return id?.startsWith("new:") ?? false;
}
//# sourceMappingURL=ids.js.map